import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { buildQueryParams } from '../../utils/object';

export const cropStageApi = createApi({
  reducerPath: 'cropStageApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ['CropStage'],

  endpoints: (builder) => ({
    createCropStage: builder.mutation({
      query: (payload) => ({
        url: `/crop-stages/create`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['CropStage'],
    }),

    getStagesByCrop: builder.query({
      query: ({ crop_id, page, limit, search, pruning_type } = {}) => ({
        url: `/crop-stages/${crop_id}`,
        params: buildQueryParams({ page, limit, search, pruning_type }),
      }),
      providesTags: ['CropStage'],
    }),

    updateStage: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/crop-stages/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['CropStage'],
    }),

    deleteStage: builder.mutation({
      query: (id) => ({
        url: `/crop-stages/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CropStage'],
    }),
  }),
});

export const {
  useCreateCropStageMutation,
  useGetStagesByCropQuery,
  useUpdateStageMutation,
  useDeleteStageMutation,
} = cropStageApi;
